import { render, staticRenderFns } from "./OpenSchedulerBoardFromJobLink.vue?vue&type=template&id=0a0f05dc"
import script from "./OpenSchedulerBoardFromJobLink.vue?vue&type=script&lang=ts"
export * from "./OpenSchedulerBoardFromJobLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports